import React, { useRef, useState } from 'react';
import { IonModal } from '@ionic/react';
import { OverlayEventDetail } from '@ionic/core/components';
import NavigateMap from './Map/NavigateMap';
import { close } from 'ionicons/icons';
import { CloseButton } from '../VirtualTour/virtualTourStyles';
import ToastHandler from './Toast/ToastHandler';
import { Trail } from '../../../models/Trail';

type NavigateProps = {
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<any>>;
	trail: Trail;
};
const Navigate: React.FC<NavigateProps> = ({ isOpen, setIsOpen, trail }) => {
	const [isToastOpen, setIsToastOpen] = useState(false);

	const navigate = useRef<HTMLIonModalElement>(null);
	const onWillDismiss = (ev: CustomEvent<OverlayEventDetail>) => {
		if (ev.detail.role === 'confirm') {
		}
	};
	return (
		<IonModal
			isOpen={isOpen}
			ref={navigate}
			onWillDismiss={(ev) => onWillDismiss(ev)}>
			<NavigateMap setIsToastOpen={setIsToastOpen} trail={trail} />
			{/* <ControlsContainer /> */}
			<ToastHandler isToastOpen={isToastOpen} />
			<CloseButton onClick={() => setIsOpen(false)} icon={close} />
		</IonModal>
	);
};

export default Navigate;
